import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { NotificationGridComponent } from '../notificationgrid.component';
import { ShareEndpoint } from '@core/endpoints/share.endpoint';
import { AttachedFile, Notification } from "@m4u-angular/base/entities/BaseEntities";
import { FileEndpoint } from '@core/endpoints/file.endpoint';
import { PrintBoxDialogComponent } from '@ui/dialogs/printbox-dialog/printboxdialog.component';
import { Utils } from '@core/helpers/Utils';

@Component({
    providers: ServiceBagServices,
    selector: 'app-sharing-history-grid',
    templateUrl: './sharing-history-grid.component.html'
})
export class SharingHistoryGridComponent extends NotificationGridComponent {

    @ViewChild(PrintBoxDialogComponent) printBoxDialog: PrintBoxDialogComponent;

    constructor(A: ServiceBagService, private shareEndpoint: ShareEndpoint,
        private fileEndpoint: FileEndpoint) {
        super(A, 'SharingHistoryGridComponent');
    }

    OnGoToSharedFile = (e) => {
        const notification: Notification  = e.row.data;

        if (!notification.SharedFileUID) return;

        this.Do(this.fileEndpoint.GetView(notification.SharedFileUID, true), false, response => {
            if (!response.IsSuccess) return;
            this.printBoxDialog.PDFData = Utils.ConvertToBase64(response.Entity.FileData);
            this.printBoxDialog.ShowDialogShort(() => { });
        });
    }
}
